export class ApiError extends Error {
  constructor(
    public readonly status: number,
    public readonly code: string,
    public readonly reason?: string,
    public readonly details?: unknown,
  ) {
    super(reason ?? code);
  }
}

export interface ApiOptions {
  method?: 'GET' | 'POST' | 'PUT' | 'PATCH' | 'DELETE';
  body?: unknown;
  formData?: FormData;
  signal?: AbortSignal;
  headers?: Record<string, string>;
}

/** JSON API client. Same-origin cookies carry the session. Errors are typed so screens can branch on the deny reason. */
export async function api<T>(path: string, opts: ApiOptions = {}): Promise<T> {
  const headers: Record<string, string> = { accept: 'application/json', ...(opts.headers ?? {}) };
  let body: BodyInit | undefined;
  if (opts.formData) body = opts.formData;
  else if (opts.body !== undefined) {
    headers['content-type'] = 'application/json';
    body = JSON.stringify(opts.body);
  }
  let res: Response;
  try {
    res = await fetch(path, { method: opts.method ?? (body ? 'POST' : 'GET'), headers, body, credentials: 'same-origin', signal: opts.signal });
  } catch (err) {
    if ((err as Error).name === 'AbortError') throw err;
    throw new ApiError(0, 'network');
  }
  if (res.status === 204) return undefined as T;
  const text = await res.text();
  let data: unknown = null;
  try {
    data = text ? JSON.parse(text) : null;
  } catch {
    data = null;
  }
  if (!res.ok) {
    const e = (data as { error?: { code?: string; reason?: string; details?: unknown; issues?: unknown } } | null)?.error;
    throw new ApiError(res.status, e?.code ?? `http_${res.status}`, e?.reason, e?.details ?? e?.issues);
  }
  return data as T;
}

export const qk = {
  me: ['me'] as const,
  rooms: ['rooms'] as const,
  room: (slug: string) => ['room', slug] as const,
  item: (id: string) => ['item', id] as const,
  admin: (...parts: string[]) => ['admin', ...parts] as const,
};
